import { CreateAuctionNew } from "../types/types";

import { atomWithStorage } from "jotai/utils";

export const createAuctionAtom = atomWithStorage<Partial<CreateAuctionNew>>(
  "createAuctionAtom",
  {},
  undefined,
  { getOnInit: true }
);
